import React, { useState } from 'react';
import Helmet from 'react-helmet';
import logo from '../assets/images/logo.png';
import swal from 'sweetalert2';
import { deviceDetect } from 'react-device-detect';
import * as helper from '../components/global/helper';
import { setAuthState } from '../assets/scripts/login-util';
import { checkVersion } from '../assets/scripts/versionComparer'
import { login } from './api/loginAPI';


const Login = (props) => {

    const [loginData,           setLoginData]           = useState({ remember: false });
    const [validated,           setValidated]           = useState(false);
    const [showPassword,        setShowPassword]        = useState(false);

    const handleData = (key, value)=>{
        setLoginData((d)=> { return {...d, [key] : value} });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {     
          event.stopPropagation();
          setValidated(true);
        }else{

            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });
                const deviceData = deviceDetect();
                const device = await helper.getDeviceDetails(deviceData);
                const response = await login(loginData.email, loginData.password, loginData.remember, device);

                setAuthState({
                    token           : response.Token,
                    user            : response.User,
                    FE_VERSION      : response.FE_VERSION,
                    serverTimestamp : response.serverTimestamp,
                    expiresOn       : response.expiresOn
                 }, true);

                 window.cookieChangeHandler();
                 checkVersion(response.FE_VERSION);
                 props.onLogin();
                 swal.close();
                     
            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }    
              
    };

    return (
        <div className="container">    
             <Helmet
                bodyAttributes={{
                    style: `background-color: #f9f9ffff;`,
                }}
            /> 
            <div className="row justify-content-center m-1 needs-validation">
                <div className='col-xl-4 col-lg-6 col-md-8'>
                    <div className='login-logo'>
                        <img height="100" src={logo} alt="Metro Matrix Online Consultation"/>
                    </div>
                    <form className={`needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={handleSubmit}>
                        <div className="form-floating mb-4">
                            <input 
                                onChange={({ target }) => handleData('email', target.value)}
                                value={ loginData.email || '' }
                                id="txtEmail" 
                                type="email" 
                                className="form-control" 
                                placeholder='email' 
                                required
                            />
                            <label htmlFor="txtEmail">Email</label>
                            <div className="invalid-feedback">Please enter a valid email.</div>
                        </div>
                        <div className="form-floating mb-4">
                            <input 
                                onChange={({ target }) => handleData('password', target.value)}
                                value={ loginData.password || '' }
                                id="txtPassword" 
                                type={showPassword ? 'text' : 'password'}
                                className="form-control" 
                                placeholder='password' 
                                autoComplete="off" 
                                required
                            />
                            <label htmlFor="txtPassword">Password</label>
                            <div className="invalid-feedback"> Please enter your password.</div>
                            <span
                                className='password-toggle'
                                onClick={togglePasswordVisibility}>
                                {showPassword ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                            </span>
                        </div>
                        <div className="form-check mb-4 no-validation">
                            <input 
                                defaultChecked={ loginData.remember ? "checked" : "" }
                                onChange={() => handleData("remember", !loginData.remember)}
                                id="chkRemember"              
                                type="checkbox" 
                                className="form-check-input"                              
                            />
                            <label className="form-check-label" htmlFor="chkRemember">
                                <small>Remember me</small>
                            </label>
                        </div>
                        <div className="d-grid gap-2">
                            <button className="btn btn-lg btn-primary" type="submit"><small>Login</small></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login;

